module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1300.b09c4407.png";